module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Header'), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": require("./images/banner.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bannerCon"
  }, [_c('p', {
    staticClass: "bannerTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.bannerTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "bannerSubtitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.bannerTitleEN))])])]), _vm._v(" "), _c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v(_vm._s(_vm.copyData.spring.breadcrumb) + _vm._s(_vm.breadcrumb))]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.windowWidth >= 800) ? _c('div', {
    staticClass: "leftCon"
  }, [_c('div', {
    staticClass: "titleCon"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleZH))]), _vm._v(" "), _c('p', {
    staticClass: "titleEN"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleEN))])]), _vm._v(" "), _c('div', {
    staticClass: "menuCon"
  }, [_c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 1 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 1, _vm.breadcrumb = _vm.copyData.spring.menulist01, _vm.swiperIndex = -1, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist01))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 2 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 2, _vm.breadcrumb = _vm.copyData.spring.menulist02, _vm.swiperIndex = -1, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist02))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 3 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 3, _vm.breadcrumb = _vm.copyData.spring.menulist03, _vm.swiperIndex = -1, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist03))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 4 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 4, _vm.breadcrumb = _vm.copyData.spring.menulist04, _vm.swiperIndex = -1, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist04))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 5 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 5, _vm.breadcrumb = _vm.copyData.spring.menulist05, _vm.swiperIndex = -1, _vm.getPosition()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/arrow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist05))])]), _vm._v(" "), _c('div', {
    staticClass: "phoneCon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.copyData.spring.phoneTitle))]), _vm._v(" "), _c('p', {
    staticClass: "phoneNum"
  }, [_vm._v(_vm._s(_vm.copyData.spring.phoneNum))])])])]) : _vm._e(), _vm._v(" "), (_vm.windowWidth < 800) ? _c('div', {
    staticClass: "leftCon"
  }, [_c('div', {
    staticClass: "menuCon"
  }, [_c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 1 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 1, _vm.breadcrumb = _vm.copyData.spring.menulist01, _vm.swiperIndex = -1
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist01))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 2 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 2, _vm.breadcrumb = _vm.copyData.spring.menulist02, _vm.swiperIndex = -1
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist02))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 3 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 3, _vm.breadcrumb = _vm.copyData.spring.menulist03, _vm.swiperIndex = -1
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist03))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 4 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 4, _vm.breadcrumb = _vm.copyData.spring.menulist04, _vm.swiperIndex = -1
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist04))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.tabTag == 5 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.tabTag = 5, _vm.breadcrumb = _vm.copyData.spring.menulist05, _vm.swiperIndex = -1
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.spring.menulist05))])])])]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 1) ? _c('div', {
    staticClass: "rightCon"
  }, [(_vm.swiperIndex == -1) ? _c('div', {
    staticClass: "mainCon"
  }, [_c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextOne))]), _vm._v(" "), _c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextTwo))]), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, _vm._l((_vm.imgListOne), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "listMain",
      on: {
        "click": function($event) {
          _vm.swiperIndex = index, _vm.getPosition()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
    staticClass: "swiper"
  }, [_c('el-carousel', {
    attrs: {
      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
      "width": "100%",
      "indicator-position": "none",
      "arrow": "always",
      "autoplay": false,
      "initial-index": _vm.swiperIndex
    }
  }, _vm._l((_vm.imgListOne), function(item) {
    return _c('el-carousel-item', {
      key: item
    }, [_c('div', {
      staticClass: "swiperList"
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])])
  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 2) ? _c('div', {
    staticClass: "rightCon"
  }, [(_vm.swiperIndex == -1) ? _c('div', {
    staticClass: "mainCon"
  }, [_c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextThree))]), _vm._v(" "), _c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextFour))]), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, _vm._l((_vm.imgListTwo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "listMain",
      on: {
        "click": function($event) {
          _vm.swiperIndex = index, _vm.getPosition()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
    staticClass: "swiper"
  }, [_c('el-carousel', {
    attrs: {
      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
      "width": "100%",
      "indicator-position": "none",
      "arrow": "always",
      "autoplay": false,
      "initial-index": _vm.swiperIndex
    }
  }, _vm._l((_vm.swiperListTwo), function(item) {
    return _c('el-carousel-item', {
      key: item
    }, [_c('div', {
      staticClass: "swiperList"
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])])
  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 3) ? _c('div', {
    staticClass: "rightCon"
  }, [(_vm.swiperIndex == -1) ? _c('div', {
    staticClass: "mainCon"
  }, [_c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextFive))]), _vm._v(" "), _c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextSix))]), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, _vm._l((_vm.imgListThree), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "listMain",
      on: {
        "click": function($event) {
          _vm.swiperIndex = index, _vm.getPosition()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
    staticClass: "swiper"
  }, [_c('el-carousel', {
    attrs: {
      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
      "width": "100%",
      "indicator-position": "none",
      "arrow": "always",
      "autoplay": false,
      "initial-index": _vm.swiperIndex
    }
  }, _vm._l((_vm.imgListThree), function(item) {
    return _c('el-carousel-item', {
      key: item
    }, [_c('div', {
      staticClass: "swiperList"
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])])
  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 4) ? _c('div', {
    staticClass: "rightCon"
  }, [(_vm.swiperIndex == -1) ? _c('div', {
    staticClass: "mainCon"
  }, [_c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextSeven))]), _vm._v(" "), _c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextEight))]), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, _vm._l((_vm.imgListFour), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "listMain",
      on: {
        "click": function($event) {
          _vm.swiperIndex = index, _vm.getPosition()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
    staticClass: "swiper"
  }, [_c('el-carousel', {
    attrs: {
      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
      "width": "100%",
      "indicator-position": "none",
      "arrow": "always",
      "autoplay": false,
      "initial-index": _vm.swiperIndex
    }
  }, _vm._l((_vm.swiperListFour), function(item) {
    return _c('el-carousel-item', {
      key: item
    }, [_c('div', {
      staticClass: "swiperList"
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])])
  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabTag == 5) ? _c('div', {
    staticClass: "rightCon"
  }, [(_vm.swiperIndex == -1) ? _c('div', {
    staticClass: "mainCon"
  }, [_c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleOne))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextNine))]), _vm._v(" "), _c('p', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTitleTwo))]), _vm._v(" "), _c('p', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.copyData.spring.springTextNine))]), _vm._v(" "), _c('div', {
    staticClass: "listCon"
  }, _vm._l((_vm.imgListFive), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "listMain",
      on: {
        "click": function($event) {
          _vm.swiperIndex = index, _vm.getPosition()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.swiperIndex != -1) ? _c('div', {
    staticClass: "swiper"
  }, [_c('el-carousel', {
    attrs: {
      "height": _vm.windowWidth >= 800 ? '610px' : '62.24vw',
      "width": "100%",
      "indicator-position": "none",
      "arrow": "always",
      "autoplay": false,
      "initial-index": _vm.swiperIndex
    }
  }, _vm._l((_vm.swiperListFive), function(item) {
    return _c('el-carousel-item', {
      key: item
    }, [_c('div', {
      staticClass: "swiperList"
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    })])])
  }), 1)], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('div', {
    staticClass: "scroll-top",
    on: {
      "click": _vm.backToTop
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/backTop.png")
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-159a54fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/productSpring/App.vue
// module id = 599
// module chunks = 3